/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class AccountingsDialog extends NoboxEntityDialog<AccountingsRow, any> {
        protected getFormKey() { return AccountingsForm.formKey; }
        protected getIdProperty() { return AccountingsRow.idProperty; }
        protected getLocalTextPrefix() { return AccountingsRow.localTextPrefix; }
        protected getNameProperty() { return AccountingsRow.nameProperty; }
        protected getService() { return AccountingsService.baseUrl; }
        protected getDeletePermission() { return AccountingsRow.deletePermission; }
        protected getInsertPermission() { return AccountingsRow.insertPermission; }
        protected getUpdatePermission() { return AccountingsRow.updatePermission; }

        protected form = new AccountingsForm(this.idPrefix);
        constructor() {
            super();
            $('<a class="inplace-button inplace-action3"><b><i class="fa fa-user text-primary icon-picker-ct"></i></b></a>')
                .attr("title", "Select From Contact")
                .insertAfter(this.form.FromName.element)
                .click(e => {
                    var dlg = new AccountingsContactDialog();
                    var value = this.form.CtId.value;
                    dlg.loadNewAndOpenDialog();
                    dlg.setValue(value);
                    dlg.getValue = (result,text) => {
                        this.form.CtId.value = result;
                        this.form.FromName.value = text;
                        if (Q.isEmptyOrNull(result)) {
                            this.toogleIconPickerContact(false);
                        } else {
                            this.toogleIconPickerContact(true);
                        }
                    }
                });
            var initFile = false;
            this.form.Attachment.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
        }

        getCookie(currency) {
            const value = ` ; ${document.cookie}`;
            const parts = value.split(`; ${currency}=`);

            if (parts[1] == undefined) {
                if (currency == "currency") {
                    return "Rp";
                }
            } else {
                return parts[1].split(';').shift();
            }

        };

        protected afterLoadEntity() {
            super.afterLoadEntity();
            //this.doCalculation();
        }
        toogleIconPickerContact(haveValue: boolean) {
            if (haveValue) {
                this.form.FromName.element.parent().find(".icon-picker-ct").removeClass("fa-user").addClass("fa-user-check");
            } else {
                this.form.FromName.element.parent().find(".icon-picker-ct").removeClass("fa-user fa-user-check").addClass("fa-user");
            }
        }
        updateInterface() {
            super.updateInterface();
            if (Q.isEmptyOrNull(this.get_entity().Currencies)) {
                this.form.Currencies.value = $.cookie('currencies') == undefined ? "Rp" : $.cookie('currencies');
            }
            var ctId = this.get_entity().CtId;
            if (ctId != null) {
                this.toogleIconPickerContact(true);
            } else {
                this.toogleIconPickerContact(false);
            }
        }
    }
}